import { isTauriMode } from "../environmentDetector";

const SHOW_WINDOW_SHORTCUT = "CommandOrControl+Alt+N";

export function showWindowShortcutLabel(): string {
  return "Ctrl+Alt+N";
}

export async function initDesktopShell(): Promise<void> {
  if (!isTauriMode()) return;
  try {
    const { register, isRegistered } = await import("@tauri-apps/plugin-global-shortcut");
    const already = await isRegistered(SHOW_WINDOW_SHORTCUT);
    if (!already) {
      await register(SHOW_WINDOW_SHORTCUT, async (event) => {
        if (event.state !== "Pressed") return;
        const { getCurrentWindow } = await import("@tauri-apps/api/window");
        const win = getCurrentWindow();
        await win.show();
        await win.unminimize();
        await win.setFocus();
      });
    }
  } catch (error) {
    console.warn("[desktop] The show-window shortcut was not registered.", error);
  }
  try {
    await setAutostartEnabled(true);
  } catch (error) {
    console.warn("[desktop] Open at OS startup was not enabled.", error);
  }
}

export async function readAutostartEnabled(): Promise<boolean> {
  if (!isTauriMode()) return false;
  const { isEnabled } = await import("@tauri-apps/plugin-autostart");
  return isEnabled();
}

export async function setAutostartEnabled(enabled: boolean): Promise<void> {
  if (!isTauriMode()) return;
  const { enable, disable } = await import("@tauri-apps/plugin-autostart");
  if (enabled) {
    await enable();
  } else {
    await disable();
  }
}

export async function checkApplicationUpdate(): Promise<
  | { status: "none" }
  | { status: "available"; version: string }
  | { status: "unconfigured" }
  | { status: "failed" }
> {
  if (!isTauriMode()) return { status: "unconfigured" };
  try {
    const { check } = await import("@tauri-apps/plugin-updater");
    const update = await check();
    if (!update) return { status: "none" };
    return { status: "available", version: update.version };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    if (/pubkey|endpoint|not configured|invalid/i.test(message)) {
      return { status: "unconfigured" };
    }
    console.warn("[desktop] Application update check failed.", error);
    return { status: "failed" };
  }
}
